import type { DialogProps } from '@paintscout/ui'
import React from 'react'
import { useFlags } from 'shared/components/common/FlagsProvider'
import type { EditItemFilesProps } from './EditItemFilesDialogNext'
import EditItemFilesDialogLegacy from './EditItemFilesDialogLegacy'
import EditItemFilesDialogNext from './EditItemFilesDialogNext'

export {
  mergeEditedFile,
  limitConcurrency,
  swapProviderFileInList,
  appendNewFilesToList
} from './EditItemFilesDialogNext'
export type {
  EditItemFilesProps,
  EnhancedQuoteFile,
  DropzoneError,
  UploadedFileResult
} from './EditItemFilesDialogNext'

/**
 * Switches between the new FileViewer-based editor and the legacy stepper
 * editor based on the `new-file-editor` LaunchDarkly flag (companyId-targeted).
 *
 * Both implementations share the same external EditItemFilesProps interface,
 * so all openDialog(EditItemFilesDialog, ...) call sites work with either.
 * In contexts without an LDProvider (e.g. customer-view) the flag evaluates
 * falsy and the legacy experience is used.
 */
function EditItemFilesDialog(props: DialogProps & EditItemFilesProps) {
  const { newFileEditor } = useFlags()

  return newFileEditor ? <EditItemFilesDialogNext {...props} /> : <EditItemFilesDialogLegacy {...props} />
}

export default EditItemFilesDialog
